import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { AlertService } from './alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ManualsTableService } from 'src/app/modals/Manuals/manuals-table.service';

@Injectable({ providedIn: 'root' })

export class FileUploadService {

  chunkSize: number = (5 * 1024 * 1024);
  uploadQueue: any[] = [];
  maxFileSizeMb: number = 20;
  extensions: string = "";
  folder: string = "";
  parentRecordId: number;
  downloadQueue: any[] = [];
  moduleName: string = "";
  
  constructor(
    private http: HttpClient,
    private alertService: AlertService,
    private translateService: TranslateService,
    private manualTableService: ManualsTableService
  ) {}

  // triggerUploadOption

  onDragOver(event: DragEvent){
    event.preventDefault();
  }

  onFileDrop(event: DragEvent){
    event.preventDefault();
    const fileList = event.dataTransfer?.files;
    if (fileList && fileList.length > 0) {
      const files: File[] = Array.from(fileList); // convert FileList to File[]
      this.handleFiles(files);
    }
  }

  triggerUpload(componentObject) {

    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.style.display = 'none';

    input.addEventListener('change', () => {
      const files = Array.from(input.files ?? []);
      this.handleFiles(files)
        .finally(() => {
          // Only remove the input after uploads are handled
          input.remove();
        });
      });

    document.body.appendChild(input);
    input.click();
  }

  // uploadFile & proceedUpload
  async handleFiles(files: File[]) {

    files.forEach((file, index) => {
      
      const ext = file.name.split('.').pop()?.toLowerCase();
      const extensions = this.extensions ? this.extensions?.split(',') : [];
      const isValid = extensions?.includes(ext) || !this.extensions;
      
      const maxFileSizeMb = this.maxFileSizeMb * 1024 * 1024;
      if (!isValid) {
        const errorMsg = this.translateService.instant("ALERTS.file-no-upload-extension")+" "+this.extensions;
        this.alertService.triggerAlert(errorMsg, "error");
        return;
      }
      else if(file.size > maxFileSizeMb){
        const errorMsg = this.translateService.instant("ALERTS.file-max-size-check")+" "+this.maxFileSizeMb+" mb";
        this.alertService.triggerAlert(errorMsg, "error");
        return;
      }

      const fileIndex = `${this.parentRecordId}_${Date.now()}_${index}`;
      this.uploadQueue.push({
                            fileIndex,
                            file,
                            fileId: "",
                            parentRecordId: this.parentRecordId,
                            isUploading: false,
                            isUploaded: false,
                            isCancelled: false,
                            percentage: 0,
                            uploadedIndex: 0,
                            retries: 0,
                            totalChunks: Math.ceil(file.size / this.chunkSize),
                            dateTime: Math.floor(new Date().getTime() / 1000),
                            created_at: ""
                        });

    });

    // checkQueue
    this.processQueue();
  }

  // checkQueue
  processQueue() {
    const file = this.uploadQueue.find(f => !f.isUploading && !f.isUploaded && !f.isCancelled);

    if (file) this.uploadFile(file); //File is being passed with reference so it makes changes directly to uploadQueue
  }


  //triggerUpload uploadChunk
  uploadFile(file: any) {

    if(this.moduleName == "manuals" && file.fileId === ""){
      console.log("ere");
      console.log(file);
      this.manualTableService.videoFileId = "";
      this.manualTableService.videoSrc = "";
    }

    if (file.isCancelled || file.isUploaded) return;

    file.isUploading = true;
    const start = file.uploadedIndex * this.chunkSize;
    const end = Math.min(start + this.chunkSize, file.file.size);
    const chunk = file.file.slice(start, end);

    const formData = new FormData();
    formData.append('chunk', chunk);
    formData.append('index', file.uploadedIndex);
    formData.append('totalChunks', file.totalChunks);
    formData.append('fileName', file.file.name);

    const params = new HttpParams()
            .set('folder', this.folder)
            .set('datetime', file.dateTime)
            .set('fileindex', file.fileIndex)
            .set('fileID', file.fileId ?? '');

    this.http.post<any>(`upload-file-chunks/${file.parentRecordId}`, formData, { params }).subscribe({
      next: res => {

        if(res.result){

          file.fileId = res.fileID;
          file.created_at = res.created_at;
          file.uploadedIndex += 1;
          file.percentage = Math.round((file.uploadedIndex / file.totalChunks) * 100);
  
          if (file.uploadedIndex < file.totalChunks) {
            if(file.isCancelled == false){
              this.uploadFile(file);
            }
          } else {
            
            file.isUploaded = true;
            file.isUploading = false;
            this.uploadCompletionAction(file);

            if(this.moduleName == "manuals"){
              this.fetchPlayableFile(file.parentRecordId, file.fileId, "manual_files");
            }
          }

        }
        else if(res.failure){
          this.handleCancellation(file.fileIndex, file.file.name, file.dateTime);
        }
        else {
          this.retryChecker(file);
        }

      },
      error: () => {
        this.retryChecker(file);
      }
    });
  }

  retryChecker(file){

    if (file.retries < 5) {
      file.retries += 1;
      this.uploadFile(file);
    } else {
      file.isUploading = false;
      file.isCancelled = true;
      //checkQueue
      this.processQueue();
      this.handleCancellation(file.fileIndex, file.file.name, file.dateTime);
    }

  }

  cancelUpload(fileIndex: string) {
    const file = this.uploadQueue.find(f => f.fileIndex === fileIndex);
    if (file && !file.isUploaded) {
      file.isCancelled = true;
      file.isUploading = false;

      this.handleCancellation(fileIndex, file.file.name, file.dateTime);
    }
  }

  handleCancellation(fileIndex, fileName, dateTime){

    var setFileName = dateTime + fileIndex + "_" + fileName;
    const file = this.uploadQueue.find(f => f.fileIndex === fileIndex);

    //Delete the existing file parts
    if(file.isUploaded == false){

        this.http.get<any>('delete-file-chunks/'+this.parentRecordId+"/"+file.fileId+"?folder="+this.folder).subscribe({
          next: res => {},
          error: () => {}
        });

        //Check if no files then show no files uploaded
        file.isCancelled = true;
        file.isUploading = false;
        this.removeCheckNofiles(fileIndex);
        
    }

    //checkQueue
    this.processQueue();
  }

  uploadCompletionAction(file){
    // this.uploadQueue = this.uploadQueue.filter(f => f.fileIndex !== file.fileIndex); //If want to remove the file

    //checkQueue
    this.processQueue();
  }

  removeCheckNofiles(fileIndex){
    this.uploadQueue = this.uploadQueue.filter(f => f.fileIndex !== fileIndex);
  }

  deleteFile(fileId: number, fileIndex: string) {
    this.http.get(`/delete-file/${this.parentRecordId}/${fileId}?folder=${this.folder}`).subscribe(() => {
      this.uploadQueue = this.uploadQueue.filter(f => f.fileIndex !== fileIndex);
    });
  }

  downloadFile(fileId: number, fileName: string) {
    
    const fileExist = this.downloadQueue.find(f => f.fileId === fileId);
    const someFileDownloading = this.downloadQueue.find(f => f.isDownloading === true);
    const obj = {
                  fileId: fileId,
                  isDownloading: false,
                  fileName: fileName
                };

    if(fileExist)
      return;
    else if(someFileDownloading)
      this.downloadQueue.push(obj);
    else{
      this.downloadQueue.push(obj);
      this.processDownload();
    }

  }

  processDownload(){

    const file = this.downloadQueue.find(f => f.isDownloading == false);
    if(!file)
      return;

    file.isDownloading = true;

    const downloadUrl = `download-file/${this.parentRecordId}/${file.fileId}`+"?folder="+this.folder;
    this.http.get<any>(downloadUrl).subscribe({
      next: res => {
        const data = res.data;
        if(data?.url && data?.url !== ""){

          const link = document.createElement('a');
          link.href = data.url;
          link.download = ''; // optional – browser will use filename from headers
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

        }else{
          const msg = this.translateService.instant("ALERTS.failed-to-download-no-exist")+" "+ file.fileName;
          this.alertService.triggerAlert(msg, "error");
        }

        this.downloadQueue = this.downloadQueue.filter(f => f.fileId !== file.fileId);
        this.processDownload();
      },
      error: () => {
        const msg = this.translateService.instant("ALERTS.failed-to-download-try-again")+" "+ file.fileName;
        this.alertService.triggerAlert(msg, "error");
        this.downloadQueue = this.downloadQueue.filter(f => f.fileId !== file.fileId);
        this.processDownload();
      }
    });
  }

  // fetchPlayableFile(parentRecordId: string, fileId: string, folder: string): Observable<string | false>{
  //     this.manualTableService.videoFileId = fileId;
  //     const fileUrl = `download-file/${parentRecordId}/${fileId}?folder=${folder}`;
  //     return this.http.get<any>(fileUrl).pipe(
  //       map(res => {
  //         const data = res.data;
  //         if (data?.url && data?.url !== "") {
  //           this.manualTableService.videoSrc = data.url;
  //           return data.url;
  //         } else {
  //           const msg = this.translateService.instant("ALERTS.failed-to-download-no-exist");
  //           this.alertService.triggerAlert(msg, "error");
  //           return false;
  //         }
  //       }),
  //       catchError(() => {
  //         const msg = this.translateService.instant("ALERTS.failed-to-download-try-again");
  //         this.alertService.triggerAlert(msg, "error");
  //         return of(false);
  //       })
  //     );
  // }

  fetchPlayableFile(parentRecordId: string, fileId: string, folder: string){
    this.manualTableService.videoFileId = fileId;
    const fetchUrl = `download-file/${parentRecordId}/${fileId}?folder=${folder}`;
    this.http.get<any>(fetchUrl).subscribe({
      next: res => {
        console.log(res);
        const data = res.data;
        if(data?.url && data?.url !== ""){
          this.manualTableService.videoSrc = data.url;
        }else{
          const msg = this.translateService.instant("ALERTS.failed-to-download-no-exist");
          this.alertService.triggerAlert(msg, "error");
        }
      },
      error: () => {
        const msg = this.translateService.instant("ALERTS.failed-to-download-try-again");
        this.alertService.triggerAlert(msg, "error");
      }
    });

    return;

   

  }

  get reversedUploadQueue() {
    return [...this.uploadQueue].reverse();
  }

}